import cz from '../csCZ/search';

const de: typeof cz = {
	title: 'Volkszählungsoperate und namenregister',
	title_advanced: 'Erweiterte suche',
	title_results: 'Suchergebnisse',
	year_of_census: 'Volkszählungsjahrgang',
	street: 'Straße',
	house_number: 'Hausnummer',
	first_name: 'Vorname',
	surname: 'Nachname',
	inventary_number: 'Inventarisierungsnummer',
	name_register: 'Namensregister',
	volume: 'Band',
	page: 'Seite',
	show_people: 'Personen aus den Häusern',
	perform_search: 'Suchen',
	year: 'Jahr',
	street_name: 'Strassenname',
	persons_by_registry: 'Personen nach dem Namensregister',
	operates_image: 'Operatenanzeige',
	page_text: 'Namensregisterseite (Inv.Num.; Band; Seite; Zeile)',
	no_results: 'Keine Ergebnisse gefunden',
};

export default de;
